import React from "react";

function HeartOutline() {
  return (
    <span className="anticon anticon-heart-outline">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 18 17"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeWidth="1.3"
          d="M9 15.45l-.565-.456c-3.373-2.725-5.41-4.367-6.568-6.512-.854-1.574-1.082-3.127-.662-4.49a4.232 4.232 0 012.234-2.584A4.128 4.128 0 015.251 1c1.529 0 2.968.798 3.75 2.036C9.781 1.798 11.222 1 12.749 1a4.24 4.24 0 014.047 2.992c.42 1.363.19 2.916-.663 4.49-1.16 2.146-3.198 3.79-6.575 6.517L9 15.451z"
        ></path>
      </svg>
    </span>
  );
}

export default HeartOutline;
